//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateBancos } from "@/typings/store/plugins/easyFirestore/bancos";

const getters: GetterTree<StateBancos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const bancos = {
    firestorePath: "dev/v1/bancos",
    firestoreRefType: "collection",
    moduleName: "bancos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default bancos;
